import { AppDownloadButtons } from '../components/AppDownloadButtons';
import './ClosingCta.css';

export const ClosingCta = () => (
  <section className="tl-closing" id="get-tulink" aria-labelledby="tl-closing-heading">
    <div className="tl-shell">
      <div className="tl-closing__manifesto tl-reveal">
        <p className="tl-closing__line">
          The technology fades back.
          <br />
          The shared story moves forward.
        </p>
        <span className="tl-closing__rule" aria-hidden="true" />
      </div>

      <div className="tl-closing__panel tl-surface-dark tl-reveal">
        <div className="tl-closing__panel-copy">
          <h2 id="tl-closing-heading">Ready to travel together?</h2>
          <p className="tl-closing__panel-lede">
            Get Tulink and keep your next journey connected from start to finish.
          </p>
        </div>
        <AppDownloadButtons inverse className="tl-closing__cta" />
      </div>
    </div>
  </section>
);
